import React from 'react'
import { withAppContext, getToken } from '@ctsu/loader'
import {
  Header,
  HelpContainer,
  Footer,
  GoogleAnalytics,
  Notification
} from '@ctsu/react-ctsu-ui'
import { NavLink } from 'react-router-dom'
import AppRoutes from 'routes'
import buildInfo from 'components/BuildInfo/build_info-lock.json'
import CTSUErrorBoundary from 'components/ErrorBoundary'

function logout() {
  return <NavLink key="imp" to="/logout">
    Logout
  </NavLink>
}

function Layout(props) {
  const { children, context } = props
  const { session, application } = context
  const GACode = type =>
  ({
    LOCAL: 'UA-178640855-5',
    CI: 'UA-178640855-5',
    UNIT: 'UA-178640855-5',
    TEST: 'UA-178640855-4',
    UAT: 'UA-178640855-3',
    PROD: 'UA-178640855-2'
  }[type])

  const websiteEnv = window.location.hostname
  let gaTrackingId = ''
  if (websiteEnv.search('unit-') >= 0) {
    gaTrackingId = GACode('UNIT')
  } else if (websiteEnv.search('uat-') >= 0) {
    gaTrackingId = GACode('UAT')
  } else if (
    websiteEnv.search('ci-') >= 0 ||
    websiteEnv.search('localhost') >= 0
  ) {
    gaTrackingId = GACode('CI')
  } else if (websiteEnv.search('test-') >= 0) {
    gaTrackingId = GACode('TEST')
  } else {
    gaTrackingId = GACode('PROD')
  }

  const callbackFun = () => {
    // This is added for demo
  }

  return (
    <>
      <GoogleAnalytics application={application} gaTrackingId={gaTrackingId} />
      <div
        className={`${session == null ? 'header-nav-override-revert' : 'header-nav-override'
          }`}>
        <CTSUErrorBoundary>
          <Header
            appName={application.appName}
            displayAppName="Portal"
            key="portal.header"
            subName=""
            dbName={application.dbName}
            userPermissions={session && session.userPermissions}
            impersonateContext={context}
            userFirstLast={session && session.userFirstLast}
            fnToken={getToken}
            coreVersion="v1"
            username={session && session.username}
            impersonateLevel={session && session.impersonateLevel}
            lastLogin={session && session.lastLogin}
            ctepId={session && session.ctepId}
            pwdExpiryDays={session && session.pwdExpiryDays}
            session={session}
            routes={AppRoutes}
            logout={logout} 
            notifDismisCbFn={callbackFun} />

          <Notification
            fnToken={getToken}
            appName={application.appName}
            isMaintainer
            coreVersion="v1"
            appContext={context}
            isPublic
          />
        </CTSUErrorBoundary>
      </div>
      <CTSUErrorBoundary>
        <div>
          <HelpContainer
            appName="PORTAL"
            getToken={getToken}
            appUrl={process.env.REACT_APP_ORIGIN}
          />
        </div>
        <div className="main app-body">
          <div className="app-spacing">
            <div className="app-body-content">{children}</div>
          </div>
        </div>
        <Footer
          buildInfo={{
            buildVersion: buildInfo.build_version,
            buildDate: buildInfo.build_date
          }}
          dbName={application.dbName}
        />
      </CTSUErrorBoundary>
    </>
  )
}
export default withAppContext(Layout)
